import ActionTypes from '../constants';

const initialState = {
    customers: {},
    customer: {}
    // loading: false,
};

const customerReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETCUSTOMERSUCCESS:
            return {
                ...state,
                customers: action.payload,
            }
        case ActionTypes.GETCUSTOMERBYIDSUCCESS:
            return {
                ...state,
                customer: action.payload,
            }
        default:
            return state;
    }
}

export default customerReducer;